import { render, staticRenderFns } from "./GenericButton.vue?vue&type=template&id=80e8d0d0"
import script from "./GenericButton.vue?vue&type=script&lang=js"
export * from "./GenericButton.vue?vue&type=script&lang=js"
import style0 from "./GenericButton.vue?vue&type=style&index=0&id=80e8d0d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports